import * as React from "react";
const SvgCollapseAllAccordion = (props) => /* @__PURE__ */ React.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 11 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0.899889 19.0578L0.192139 18.35L5.49989 13.0423L10.8076 18.35L10.0999 19.0578L5.49989 14.4578L0.899889 19.0578ZM5.49989 6.45776L0.192139 1.15001L0.899889 0.442261L5.49989 5.04226L10.0999 0.442261L10.8076 1.15001L5.49989 6.45776Z", fill: "currentColor", style: {
  fill: "currentColor",
  fillOpacity: 1
} }));
export default SvgCollapseAllAccordion;
